import Community from '@models/Community'
import Domain from '@models/Domain'
import ApiRoutes from '@utils/api-routes'
import http, { HTTPResponse } from '@utils/http'

/////
// Check Email
type CheckEmailResponse = {
  email_taken: boolean
  invalid_chars: boolean
}
export async function checkEmail(email: string): Promise<CheckEmailResponse | null> {
  const [resp] = await http.post<CheckEmailResponse>(ApiRoutes.clientCheckEmailPath(), { email })
  if (!resp?.data) return null
  return resp.data
}

/////
// Check Username
type CheckUsernameResponse = {
  username: string
  username_taken: boolean
  invalid_chars: boolean
}
export async function checkUsername(username: string): Promise<CheckUsernameResponse | null> {
  const [resp] = await http.post<CheckUsernameResponse>(ApiRoutes.clientCheckUsernamePath(), {
    username,
  })
  if (!resp?.data) return null
  return resp.data
}

/////
// Register User
type RegisterUserRequest = {
  email: string
  username: string
  password: string
  password_confirmation: string
  captcha_response: string
  metadata: {
    age: number
  }
}
type RegisterUserResponse = unknown
export async function registerUser(
  params: RegisterUserRequest
): Promise<RegisterUserResponse | null> {
  const [resp] = await http.post<RegisterUserResponse>(
    ApiRoutes.clientRegisterAndSendActivationPath(),
    params
  )
  if (!resp?.data) return null
  return resp.data
}

/////
// Login User
type LoginResponse = unknown
export async function loginUser(
  username: string,
  password?: string,
  code?: string
): HTTPResponse<LoginResponse> {
  return http.post<LoginResponse>(
    ApiRoutes.clientLoginPath(),
    {
      signon: username,
      password,
      code,
    },
    {
      hideGlobalError: true,
    }
  )
}

/////
// Reset Password
type ResetPasswordResponse = unknown
export async function resetPassword(email: string): HTTPResponse<ResetPasswordResponse> {
  return http.post<ResetPasswordResponse>(ApiRoutes.clientResetPasswordPath(), { email })
}

/////
// Communities
type CommunitiesResponse = {
  communities: Community[]
  domains: Domain[]
}
export async function fetchCommunities(): HTTPResponse<CommunitiesResponse> {
  return http.post<CommunitiesResponse>(ApiRoutes.clientCommunitiesPath())
}
